/**
 * Shared constants for NFC reader communication URLs and memory bank IDs
 * used by both read-device and read-device-multi-driver components.
 */

export const READER_BASE_URL = "http://localhost:2020";
export const READER_START_URL = "/server/v1/status";
export const READER_LIST_URL = "/peripheral/v1/types";
export const READER_DATA_URL = "/device/v1/NFC/LCN9600/dummy/memorybank/114";
export const DEVICE_INFO_URL = "/peripheral/v1/nfc/{peripheralId}/devices";
export const DEVICE_INFO_REFRESH_URL = "/peripheral/v1/nfc/{peripheralId}/devices?refresh=true";
export const MEMORY_BANK_URL = "/device/v1/nfc/{peripheralId}/{deviceNfcId}/memorybanks/metadata";
export const CORRUPT_BIT_URL = "/device/v1/nfc/{peripheralId}/{deviceNfcId}/memorybanks/corrupt";
export const WRITING_IN_DEVICE_URL = "/device/v1/nfc/{peripheralId}/{deviceNfcId}/memorybanks";
export const FORMATTED_MEMORY_BANK_URL = "/device/v1/nfc/{peripheralId}/{deviceNfcId}/memorybanks/formatted";
export const PAYLOAD_URL = "/device/v1/nfc/{peripheralId}/{deviceNfcId}/memorybanks";
export const IMPORT_PAYLOAD_URL = "feature/api/v1/configuration/{configurationId}/feature-payload";
export const IMPORT_PAYLOAD_URL_NE = "feature/api/v1/configuration/{configurationId}/feature-payload/not-encrypted";

/** Common memory bank IDs shared by all reader components */
export const COMMON_MEMORY_BANKS = [
  { memoryBankId: "114-0" },  // AOC
  { memoryBankId: "73-0" },   // ALO
  { memoryBankId: "37-0" },   // ALO MIN
  { memoryBankId: "14-0" },   // CLO/CLOLITE
  { memoryBankId: "149-0" },  // AOC PWM
  { memoryBankId: "29-0" },   // AST
  { memoryBankId: "1-0" },    // LUMIN
  { memoryBankId: "35-0" },   // SRPSU
  { memoryBankId: "19-0" },   // ZTV
  { memoryBankId: "52-0" },
  { memoryBankId: "13-0" },   // LUMIN
  { memoryBankId: "15-0" },   // LINESWITCH
  { memoryBankId: "18-0" },   // AMPDIM
  { memoryBankId: "75-0" },   // DC EMERGENCY
  { memoryBankId: "74-0" },   // DTL
  { memoryBankId: "113-0" },  // DTL
  { memoryBankId: "36-0" },   // Coded Mains
];

/** Additional memory banks for single-device read (extends COMMON_MEMORY_BANKS) */
export const EXTENDED_MEMORY_BANKS = [
  ...COMMON_MEMORY_BANKS,
  { memoryBankId: "121-0" },  // FLEXTUNE
  { memoryBankId: "119-0" },  // FLEXTUNE-OFFSET
  { memoryBankId: "161-0" },  // MULTI CONFIG MODE
  { memoryBankId: "43-0" },   // OWP
  { memoryBankId: "95-0" },   // DALI102
  { memoryBankId: "96-0" },   // DALI102and207
  { memoryBankId: "190-6" },  // AUX
  { memoryBankId: "46-0" },   // LSI
  { memoryBankId: "193-3" },  // AOC Multichannel
  { memoryBankId: "133-0" },  // OTP
  { memoryBankId: "132-0" },  // DSC
];

/** Memory bank for Dali 253 Maintenance */
export const DALI253_MEMORY_BANK = { memoryBankId: "207-0" };
